import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-index',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthenticationService,
    private route: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private cookieService: CookieService,
  ) {}

  loading = false;
  showPassword = false;
  customer = {
    email: '',
    password: '',
  };
  showErrorMessage = false;
  accountNotActivated = false;
  cookiePath: any = environment.COOKIE_PATH;

  ngOnInit(): void {
    document.documentElement.style.backgroundColor = '#ffffff';
    document.body.style.backgroundColor = '#ffffff';
  }

  ngOnDestroy(): void {
    document.documentElement.style.backgroundColor = '';
    document.body.style.backgroundColor = '';
  }

  login() : void {
    if (!this.customer.email || !this.customer.password) {
      return;
    }
    this.showErrorMessage = false;
    this.accountNotActivated = false;
    this.spinner.show();
    this.authService.authenticate(this.customer).subscribe((data: any) => {
        this.spinner.hide();
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 1);
        const userData = data.system_user;
        this.cookieService.set('cid', data.token, expirationDate, this.cookiePath);
        this.cookieService.set('user_id', String(userData.id), expirationDate, this.cookiePath);
        this.cookieService.set('user_name', userData.first_name, expirationDate, this.cookiePath);
        this.cookieService.set('email', userData.email, expirationDate, this.cookiePath);
        this.cookieService.set('role', userData.id_role_label ?? userData.role_label ?? 'Admin', expirationDate, this.cookiePath);

        this.route.navigate(['/dashboard']);
      },
      (error: any) => {
        this.spinner.hide();
        this.loading = false;
        if (error.status == 403) {
          this.accountNotActivated = true;
        } else {
          this.showErrorMessage = true;
        }
        this.toaster.error('Invalid email or password');
      });
  }

}
